import React, { useRef, useEffect } from "react";
// import { useInViewport } from "react-in-viewport";
import "../style/Img.scss";

const Img = (prop) => {
  const { imgurl, thisClass, caption, bg } = prop;

  // console.log(prop);
  // const imgRef = useRef(null);
  // const { inViewport } = useInViewport(imgRef);

  // useEffect(() => {
  //   if (thisClass === "cover-img") {
  //     if (inViewport) {
  //       imgRef.current.style.transform = `scale(1.3)`;
  //     } else {
  //       imgRef.current.style.transform = `scale(1)`;
  //     }
  //   }
  // }, [inViewport]);

  return (
    <div className={"img-block"}>
      {/* <div className="body-text"> */}
      <div
        className={thisClass}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/${imgurl})`,
          backgroundSize: "cover",
        }}
      >
        {/* <img src={process.env.PUBLIC_URL + "/" + imgurl} />
        <div className="img-caption">{caption}</div> */}
      </div>
      {/* </div>  */}
    </div>
  );
};

export default Img;
